import { useEffect, useState } from "react";
import { isPrerender } from "../lib/isPrerender";

export const useApi = <T>(url: string | null): T | null => {
    const [response, setResponse] = useState<T | null>(null);

    const getApiResponse = async (filledUrl: string) => {
        try {
            const res = await fetch(filledUrl);
            const responseValue = await res.json();
            setResponse(responseValue);
        } catch {
            // Swallow failures (e.g., react-snap blocks third-party fetches).
        }
    };

    useEffect(() => {
        if (url && !isPrerender()) {
            getApiResponse(url);
        }
    }, [url]);

    return response;
};
